import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Brands, VendorLookup } from 'shared/types';

export function useVendorSearch(query: string, brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isFetching, isLoading } = useQuery<Record<keyof VendorLookup, string>[], Error>(
    ['vendor', query],
    () =>
      quoteService.autoCompleteSearch<VendorLookup>({
        query,
        brand,
        searchColumn: 'vendorname',
        table: 'vendors',
      }),
    {
      initialData: [],
      enabled: Boolean(query),
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
    }
  );

  return { data, isFetching, isLoading } as const;
}
